export const bg = {
    LEFT: 'Ляво: преход до предишния ден.',
    RIGHT: 'Десен: преминаване към следващия ден.',
    DOWN: 'Надолу: преминете към следващия ред.',
    UP: 'До: отиди на предишния ред.',
    PGUP: 'До: преместване към предишния месец.',
    PGDOWN: 'PgDown: отиди на следващия месец.',
    HOME: 'Къща: отидете на предишната година.',
    END: 'Край: да се прехвърлят в следващата година.',
    ESC: 'Эку/днес/затваряне: затворете календар. Инструкции За',
    TITLE: 'Клавиатура '
};
